import type { RouteRecordRaw } from 'vue-router';

export default <RouteRecordRaw[]>[
  // ACTIVE CART
  {
    path: 'animal/outcome/',
    name: 'animal-outcome',
    component: () => import('./views/CartView.vue'),
    meta: {
      checkoutStatus: 'active',
    },
  },
  {
    path: 'animal/outcome/:id',
    name: 'animal-outcome-with-id',
    component: () => import('./views/CartView.vue'),
    meta: {
      checkoutStatus: 'active',
    },
  },
  {
    path: 'animal/intake-payemnt/',
    name: 'animal-intake-payment',
    component: () => import('./views/CartView.vue'),
    meta: {
      checkoutStatus: 'active',
    },
  },
  {
    path: 'animal/intake-payment/:id',
    name: 'animal-intake-with-id',
    component: () => import('./views/CartView.vue'),
    meta: {
      checkoutStatus: 'active',
    },
  },
  {
    path: 'donation/payment/',
    name: 'donation-intake-payment',
    component: () => import('./views/CartView.vue'),
    meta: {
      checkoutStatus: 'active',
    },
  },
  {
    path: 'donation/payment/:id/:isAnonymous?',
    name: 'donation-with-id',
    component: () => import('./views/CartView.vue'),
    meta: {
      checkoutStatus: 'active',
    },
  },

  // PENDING PAYMENT CART
  {
    path: 'animal/outcome-pending/:id',
    name: 'animal-outcome-pending',
    component: () => import('./views/CartCheckoutPendingView.vue'),
    meta: {
      checkoutStatus: 'pending',
    },
  },
  {
    path: 'animal/intake-payment-pending/:id',
    name: 'animal-intake-payment-pending',
    component: () => import('./views/CartCheckoutPendingView.vue'),
    meta: {
      checkoutStatus: 'pending',
    },
  },
  {
    path: 'donation/payment-pending/:id',
    name: 'donation-payment-pending',
    component: () => import('./views/CartCheckoutPendingView.vue'),
    meta: {
      checkoutStatus: 'pending',
    },
  },

  // COMPLETED CART
  {
    path: 'animal/outcome-completed/:id',
    name: 'animal-outcome-completed',
    component: () => import('./views/CartCompletedOutcomeView.vue'),
    meta: {
      checkoutStatus: 'completed',
    },
  },
  {
    path: 'animal/intake-payment-completed/:id',
    name: 'animal-intake-payment-completed',
    component: () => import('./views/CartCompletedOutcomeView.vue'),
    meta: {
      checkoutStatus: 'completed',
    },
  },
  {
    path: 'donation/payment-completed/:id',
    name: 'donation-payment-completed',
    component: () => import('./views/CartCompletedOutcomeView.vue'),
    meta: {
      checkoutStatus: 'completed',
    },
  },
];
